export default {"src":"/_next/static/media/picture.64800b1c.svg","height":68,"width":68,"blurWidth":0,"blurHeight":0};